import { SDLUtil, RequestUtil, StringUtil, DateUtil } from '@/utils';

const setGridData = ({ commit }, data) => {
  commit('SET_GRID_DATA_GRID_EXMPL', data);
};

const setProjectList = ({ commit }, data) => {
  commit('SET_PROJECT_LIST_GRID_EXMPL', data);
};

export default {
  async SEARCH_GRID_GRID_EXMPL(store, param) {
    const searchPeriod = DateUtil.stdFormat(param.searchPeriod);
    param = { ...param, ...searchPeriod };
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/sample/grid-exmpl/grid-with-paging?${StringUtil.queryStringfy(param)}`);
    console.log(data.data);
    setGridData(store, data.data);
  },
  async SEARCH_PROJECT_LIST_GRID_EXMPL(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/sample/grid-exmpl/project?${StringUtil.queryStringfy(param)}`);

    setProjectList(store, data.data);
  },
  async EXCEL_UPLOAD_GRID_EXMPL(store, param) {
    console.log(param);
    await RequestUtil.post(`${SDLUtil.API_URL}/sample/grid-exmpl/excel-upload`, param);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/sample/gridExmpl/gridExmplAction.js